import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { FileText, Download, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const TYPES = ["workers", "subcontractors", "a1_expiry", "baustelle_workforce", "missing_documents"];
const FORMATS = ["csv", "xlsx", "pdf"];

export default function SubReports() {
  const { t } = useTranslation();
  const [busy, setBusy] = useState("");
  const download = async (rtype, format) => {
    setBusy(`${rtype}:${format}`);
    try {
      const r = await api.get(`/subcon/reports/${rtype}?format=${format}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `${rtype}.${format}`; a.click(); URL.revokeObjectURL(url);
    } catch { toast.error("Error"); } finally { setBusy(""); }
  };
  return (
    <div data-testid="sub-reports" className="grid gap-4 sm:grid-cols-2">
      {TYPES.map((rt) => (
        <div key={rt} className="card-soft p-5" data-testid={`report-${rt}`}>
          <div className="mb-3 flex items-center gap-2"><span className="flex h-9 w-9 items-center justify-center rounded-xl bg-cyan/10 text-cyan-dark"><FileText className="h-4 w-4" /></span><h3 className="font-heading font-bold text-navy">{t(`sub.rep_${rt}`)}</h3></div>
          <div className="flex flex-wrap gap-2">
            {FORMATS.map((fmt) => (
              <Button key={fmt} size="sm" variant="outline" onClick={() => download(rt, fmt)} disabled={busy === `${rt}:${fmt}`} data-testid={`report-${rt}-${fmt}`} className="rounded-full uppercase">
                {busy === `${rt}:${fmt}` ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><Download className="mr-1 h-3.5 w-3.5" /> {fmt}</>}
              </Button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
